import useFetch from '@hooks/useFetch';
import { getIsLoggedIn } from '@api/selectors/auth';
import useMyInfo from '@api/hooks/auth/useMyInfo';

const usePendingPaymentStatus = (goalUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { data: pendingPaymentStatus, ...rest } = useFetch(
    goalUID && isLoggedIn
      ? `v1/subscriptions/pending_method/status/?goal_uid=${goalUID}`
      : null
  );

  return { pendingPaymentStatus, ...rest };
};

export default usePendingPaymentStatus;
